import type { ViewId } from './types';
import { $ } from './ui';

const ALL_VIEWS: ViewId[] = ['uploadView', 'extractView', 'loadingView', 'resultsView'];

export function showView(viewId: ViewId): void {
  for (const id of ALL_VIEWS) {
    const el = document.getElementById(id);
    if (el) el.classList.toggle('active', id === viewId);
  }

  const resetBtn = $('resetAppBtn');
  const showReset =
    viewId === 'resultsView' || viewId === 'extractView' || viewId === 'loadingView';
  resetBtn.style.display = showReset ? 'block' : 'none';
}
